<template>
  <!-- eslint-disable -->
  <div ref="entra_form">
    <b-row>
      <b-col sm="4" md="4" lg="2" xl="2" class="mb-md-0 mb-2">
        <b-form-group
          label="Tipo de Establecimiento"
          label-for="establishmentType"
        >
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="[
              { label: 'Tienda', value: 'STORE' },
              { label: 'Almacén', value: 'WAREHOUSE' },
            ]"
            label="label"
            v-model="form.establishmentType"
            :reduce="(option) => option.value"
            input-id="establishmentType"
            @input="filterStoresByType"
            placeholder="Seleccione un tipo"
          />
        </b-form-group>
      </b-col>
      <b-col sm="4" md="4" lg="3" xl="3" class="mb-md-0 mb-2">
        <b-form-group label="Establecimiento Origen" label-for="storeOrigin">
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="filteredStores"
            label="name"
            v-model="form.storeOrigin"
            :reduce="(locals) => locals.id"
            input-id="storeOrigin"
            @input="loadAutoparts"
          />
        </b-form-group>
      </b-col>
      <b-col sm="4" md="4" lg="3" xl="3" class="mb-md-0 mb-2">
        <b-form-group
          label="Establecimiento Destino"
          label-for="storeDestination"
        >
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="localsDestination"
            label="name"
            v-model="form.storeDestination"
            :reduce="(localsDestination) => localsDestination.id"
            input-id="storeDestination"
          />
        </b-form-group>
      </b-col>
      <b-col sm="6" md="6" lg="2" xl="2" class="mb-md-0 mb-2">
        <b-form-group label="Descripción">
          <b-form-textarea
            id="description"
            placeholder="Descripción"
            resize
            autofocus
            trim
            v-model="form.description"
            rows="1"
          />
        </b-form-group>
      </b-col>
      <b-col sm="4" md="4" lg="2" xl="2">
        <b-form-group label="Documento" label-for="document">
          <b-form-input
            id="document"
            placeholder="N° Documento"
            v-model="form.document"
            trim
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Formulario para agregar datos -->
    <div class="mt-2">
      <b-row>
        <!-- Autoparte -->
        <b-col  md="12">
          <b-form-group label="Autoparte">
            <v-select
              :options="autoparts"
              label="label"
              v-model="newItem.description"
              placeholder="Seleccione una autoparte"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :reduce="(autopart) => autopart"
              :filterable="true"
              :filter-by="customFilter"
              @input="updateQtyAvailable"
            />
          </b-form-group>
        </b-col>

        <!-- Cantidad Disponible -->
        <b-col sm="6" md="4" lg="2">
          <b-form-group label="Cantidad Disponible">
            <b-form-input
              type="number"
              v-model="newItem.qtyAvailable"
              readonly
            />
          </b-form-group>
        </b-col>

        <!-- Cantidad Requerida -->
        <b-col sm="6" md="4" lg="2">
          <b-form-group label="Cantidad Requerida">
            <b-form-input
              v-model="newItem.requiredQty"
              @keypress="validateRequiredQty"
              type="number"
              placeholder="Ingrese cantidad requerida"
            />
          </b-form-group>
        </b-col>

        <b-col sm="5" md="2" class="d-flex align-items-center mt-1">
          <b-button variant="primary" @click="addRow">Agregar</b-button>
        </b-col>
        <b-col
          sm="2"
          md="2"
          class="mb-md-0 mt-1 d-flex align-items-center justify-content-center w-80"
          v-if="tableItems.length > 0"
        >
          <b-button
            class="w-100 justify-content-center"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            @click.prevent="register"
          >
            Registrar
          </b-button>
        </b-col>
      </b-row>
    </div>

    <!-- Tabla inferior -->
    <b-card no-body class="mb-1" v-if="tableItems.length > 0">
      <b-table
        :items="tableItems"
        :fields="fields"
        responsive
        hover
        class="position-relative border border-2 rounded mt-2"
      >
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="removeRow(data.index)">
            Eliminar
          </b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import StoreService from "@/services/StoresService";
import InternalMovement from "@/services/InternalMovement";
import InventoryService from "@/services/InventoryService";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      showLoading: false,
      idStore: null,
      form: {
        document: "",
        description: "",
        storeOrigin: "",
        storeDestination: "",
        details: [],
      },
      categories: [],
      newItem: {
        description: null,
        requiredQty: null,
        requiredQty: null,
      },
      tableItems: [],
      locals: [],
      localsDestination: [],
      records: [],
      autoparts: [],
      establishmentType: "",
      fields: [
        {
          key: "description.autopart.uniqueCode",
          label: "Código Único",
          sortable: false,
        },
        {
          key: "description.autopart.AutopartBrand.name",
          label: "Marca Autoparte",
          sortable: false,
        },
        {
          key: "description.autopart.originalCode",
          label: "Codigo Original",
          sortable: false,
        },
        {
          key: "description.autopart.alterCode",
          label: "Código Alterno",
          sortable: false,
        },
        {
          key: "description.autopart.description",
          label: "Descripción",
          sortable: false,
        },
        {
          key: "description.autopart.autopartCategory.name",
          label: "Categoria",
          sortable: false,
        },
        { key: "requiredQty", label: "Cantidad Requerida", sortable: false },
        { key: "actions", label: "Acciones", sortable: false },
      ],
      filteredStores: [],
      userData: [],
      storeOrigin: null,
      storeDestination: null,
      items: [],
      cont: 1,
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: "id",
      order: "desc",
    };
  },
  components: {
    vSelect,
  },
  mounted() {
    this.getData();
  },

  watch: {
    "form.storeOrigin": "loadAutoparts",

    "form.storeOrigin": function (newValue) {
      this.newItem.description = null;
      this.newItem.qtyAvailable = null;
      this.newItem.requiredQty = null;

      this.tableItems = [];

      if (newValue) {
        this.loadAutoparts(newValue);
      } else {
        this.categories = [];
      }
    },

    "newItem.description": function (newValue) {
      this.newItem.qtyAvailable = null;
      this.newItem.requiredQty = null;

      if (newValue) {
        this.updateQtyAvailable();
      }
    },

    "form.establishmentType": function (newValue) {
      this.form.storeOrigin = null;
      this.newItem.description = null;
      this.newItem.qtyAvailable = null;
      this.newItem.requiredQty = null;

      this.tableItems = [];

      this.categories = [];
      this.autoparts = [];
      this.filteredStores = [];

      this.filterStoresByType();
    },
  },

  methods: {
    filterStoresByType() {
      if (!this.form.establishmentType) {
        this.filteredStores = [];
      } else {
        this.filteredStores = this.locals.filter(
          (store) => store.establishmentType === this.form.establishmentType
        );
      }
    },

    validateRequiredQty(event) {
      const maxQty = parseInt(this.newItem.qtyAvailable) || 0;
      const currentValue = this.newItem.requiredQty?.toString() || "";
      const char = String.fromCharCode(event.keyCode || event.which);

      const newValue = parseInt(currentValue + char) || 0;

      if (newValue > maxQty || isNaN(newValue)) {
        event.preventDefault();
      }
    },

    customFilter(option, label, search) {
      if (!search) return true;
      const normalizedLabel = label.toLowerCase();
      const normalizedSearch = search.toLowerCase().split(" ");
      return normalizedSearch.every((word) => normalizedLabel.includes(word));
    },

    async loadAutoparts() {
      if (!this.form.storeOrigin) return;
      const response = await InventoryService.getStockxStore(
        this.form.storeOrigin,
        this.$store
      );
      this.autoparts = response.data.map((item) => ({
        id: item.autopart.id,
        label: `${item.autopart.AutopartBrand.name} - ${item.autopart.originalCode} - ${item.autopart.description}`,
        autopart: item.autopart,
        qtyAvailable: item.qtyAvailable,
      }));
    },

    updateQtyAvailable() {
      if (!this.newItem.description) {
        this.newItem.qtyAvailable = null;
        return;
      }
      this.newItem.qtyAvailable = this.newItem.description.qtyAvailable;
    },

    addRow() {
      if (
        !this.newItem.description ||
        !this.newItem.requiredQty
      ) {
        this.$swal("Error", "Todos los campos son obligatorios", "error");
        return;
      }
      this.tableItems.push({ ...this.newItem });
      this.newItem = {
        description: "",
        requiredQty: null,
      };
    },

    async getData() {
      this.locals = [];
      this.localsDestination = [];
      const url = `?limit=100&page=${this.currentPage}&order=${
        this.order
      }&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`;
      const resp = await StoreService.getStores(url, this.$store);
      if (resp.data.rows.length != 0) {
        this.locals = resp.data.rows;
        this.filterStoresByType();
      }
      let datosUser = JSON.parse(localStorage.getItem("userData"));
      if (datosUser && datosUser.data && datosUser.data.userEstablishments) {
        datosUser.data.userEstablishments.forEach((element) => {
          this.localsDestination.push({
            id: element.id,
            name: element.name,
          });
        });
        this.form.storeDestination = datosUser.data.establishmentDefault.id;
      }
    },
    removeRow(index) {
      this.tableItems.splice(index, 1);
    },
    async register() {
      let datosUser = JSON.parse(localStorage.getItem("userData"));
      const userId = datosUser.data.id;
      this.isDisabled = true;

      const autopartes = this.tableItems.map((item) => ({
        autopartId: item.description?.autopart?.id || item.autopart?.id,
        qty: parseInt(item.requiredQty, 10),
      }));

      if (autopartes.length === 0) {
        this.$swal({
          title: "Error",
          text: "Debe agregar al menos una autoparte.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });
        this.isDisabled = false;
        return;
      }

      const movementData = {
        establishmentOriginId: this.form.storeOrigin,
        establishmentDestinyId: this.form.storeDestination,
        description: this.form.description,
        documentCode: this.form.document,
        userRegisterId: userId,
        state: "Registrado",
        autoparts: autopartes,
      };

      console.log("Datos de movimiento:", movementData);

      const resp = await InternalMovement.saveMovements(
        movementData,
        this.$store
      );
      console.log("Respuesta del servicio:", resp);

      if (!resp.error) {
        this.$swal({
          title: "Añadido",
          text: "El movimiento ha sido registrado",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        this.isDisabled = false;
        this.items = [];
        this.form = {
          description: "",
          storeOrigin: "",
          document: "",
          details: [],
        };
        this.records = [];
        this.$router.push("/inventario/entrada/bandeja/");
      } else {
        this.$swal({
          title: "Error",
          text: "Hubo un problema al registrar el movimiento.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });
        this.isDisabled = false;
      }
    },

    selectItem(item, val) {
      if (val == true) {
        this.items.push(item);
      } else {
        const index = this.records.findIndex(
          (elemento) => elemento.id == item.id
        );
        this.records[index].value = false;
        this.items = this.items.filter((elemento) => elemento.id !== item.id);
      }
      console.log("this.items", this.items);
    },

    sortChanged(data) {
      this.sort = data.sortBy;
      if (data.sortDesc) {
        this.order = "desc";
      } else this.order = "asc";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
